import { MediaListItemPageControls } from 'modules/proposals/components/segment-renderer/media-attachment-input-list/MediaListItemPageControls';
import type { PDFDocumentProxy } from 'pdfjs-dist';
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { SizeMe } from 'react-sizeme';
import { PublicMediaSegmentListItemControls } from './PublicMediaSegmentListItemControls';

/**Source: https://github.com/wojtekmaj/react-pdf/issues/1004 */
if (typeof window !== 'undefined' && 'Worker' in window) {
  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
  ).toString();
}

interface Props {
  file: ProposalFile;
  index: number;
}

export const PublicMediaSegmentListItemPDF: React.FC<Props> = ({
  file,
  index,
}) => {
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [isExpanded, setIsExpanded] = useState(true);

  function onDocumentLoadSuccess({
    numPages: nextNumPages,
  }: PDFDocumentProxy): void {
    setNumPages(nextNumPages);
    setPageNumber(1);
  }

  function changePage(offset: number) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  return (
    <div
      className={`media-input__image ${
        isExpanded
          ? 'media-input__image--expanded'
          : 'media-input__image--collapsed'
      }`}
    >
      <SizeMe>
        {({ size }) => (
          <Document file={file.url} onLoadSuccess={onDocumentLoadSuccess}>
            <Page
              renderTextLayer={false}
              className="media-input__pdf"
              renderAnnotationLayer={false}
              pageNumber={pageNumber}
              height={size.height ? size.height : 1}
              width={size.width ? size.width : 1}
            >
              <PublicMediaSegmentListItemControls
                file={file}
                index={index}
                isExpanded={isExpanded}
                onSetIsExpanded={setIsExpanded}
              />
            </Page>
          </Document>
        )}
      </SizeMe>
      <MediaListItemPageControls
        pageNumber={pageNumber}
        numPages={numPages}
        changePage={changePage}
      />
    </div>
  );
};
